import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import service from '@services/passenger-bus'

export const fetchDrivers = createAsyncThunk('drivers/fetch', async (params, { rejectWithValue }) => {
  try { const res = await service.getDrivers(params); return { params, data: res.data, meta: res.meta } } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})
export const fetchDriver = createAsyncThunk('drivers/fetchOne', async (id, { rejectWithValue }) => { try { return await service.getDriver(id) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const addDriver = createAsyncThunk('drivers/add', async (payload, { rejectWithValue }) => { try { return await service.addDriver(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const saveDriver = createAsyncThunk('drivers/save', async (payload, { rejectWithValue }) => { try { return await service.updateDriver(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const removeDriver = createAsyncThunk('drivers/remove', async (id, { rejectWithValue }) => { try { await service.deleteDriver(id); return id } catch (e) { return rejectWithValue(e.response?.data || e.message) } })

const slice = createSlice({
  name: 'drivers',
  initialState: { data: [], meta: null, params: { page: 1, take: 10, order: 'ASC', q: '' }, selected: null, loading: false, error: null },
  reducers: { setDriverParams(s, a) { s.params = a.payload } },
  extraReducers: b => {
    b.addCase(fetchDrivers.pending, s => { s.loading = true })
     .addCase(fetchDrivers.fulfilled, (s, a) => { s.loading = false; s.data = a.payload.data; s.meta = a.payload.meta; s.params = a.payload.params })
     .addCase(fetchDrivers.rejected, (s, a) => { s.loading = false; s.error = a.payload })
     .addCase(fetchDriver.fulfilled, (s, a) => { s.selected = a.payload })
     .addCase(addDriver.fulfilled, (s, a) => { s.data.unshift(a.payload) })
     .addCase(saveDriver.fulfilled, (s, a) => { const i = s.data.findIndex(x => x.id === a.payload.id); if (i > -1) s.data[i] = a.payload })
     .addCase(removeDriver.fulfilled, (s, a) => { s.data = s.data.filter(x => x.id !== a.payload) })
  }
})

export const { setDriverParams } = slice.actions
export default slice.reducer
